import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Trademark Registration Services | Protect Your Brand',
  description = 'Professional trademark registration services with USPTO licensed attorneys. Fast filing, transparent pricing, 98% success rate. Protect your brand today.',
  keywords = 'trademark registration, trademark filing, brand protection, USPTO, trademark attorney, intellectual property',
  canonical = ''
}) => {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const fullUrl = canonical ? `${siteUrl}${canonical}` : typeof window !== 'undefined' ? window.location.href : siteUrl;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
